/**
 * Isolated localStorage keys for property/project form drafts.
 * Prevents Admin, Partner, and User portals from sharing incomplete form data.
 */

export const DRAFT_SCOPES = {
  USER: 'user',
  ADMIN: 'admin',
  PARTNER: 'partner',
};

const LEGACY = {
  property: 'property_draft',
  project: 'project_draft',
};

export function resolveDraftScope(explicitScope) {
  const normalized = String(explicitScope || '').toLowerCase();
  if (normalized === DRAFT_SCOPES.USER || normalized === DRAFT_SCOPES.ADMIN || normalized === DRAFT_SCOPES.PARTNER) {
    return normalized;
  }
  if (typeof window !== 'undefined') {
    if (window.location.pathname.startsWith('/partner')) return DRAFT_SCOPES.PARTNER;
    if (window.location.pathname.startsWith('/admin')) return DRAFT_SCOPES.ADMIN;
  }
  return DRAFT_SCOPES.USER;
}

export function getPropertyDraftKey(scope, { editId } = {}) {
  const s = resolveDraftScope(scope);
  if (editId) return `pif_${s}_property_draft_edit_${editId}`;
  return `pif_${s}_property_draft`;
}

export function getProjectDraftKey(scope, { editId } = {}) {
  const s = resolveDraftScope(scope);
  if (editId) return `pif_${s}_project_draft_edit_${editId}`;
  return `pif_${s}_project_draft`;
}

/** Profile page draft list keys (user-only). */
export function getProfileDraftKeys() {
  return {
    property: `pif_${DRAFT_SCOPES.USER}_property_draft`,
    project: `pif_${DRAFT_SCOPES.USER}_project_draft`,
  };
}

/** Move legacy user drafts into scoped keys (one-time). */
export function migrateLegacyUserDrafts() {
  try {
    const keys = getProfileDraftKeys();
    if (!localStorage.getItem(keys.property)) {
      const old = localStorage.getItem(LEGACY.property);
      if (old) localStorage.setItem(keys.property, old);
    }
    if (!localStorage.getItem(keys.project)) {
      const old = localStorage.getItem(LEGACY.project);
      if (old) localStorage.setItem(keys.project, old);
    }
    clearLegacyDraftKeys();
  } catch {
    /* ignore */
  }
}

/** One-time cleanup of legacy shared keys after migrating to scoped storage. */
export function clearLegacyDraftKeys() {
  try {
    localStorage.removeItem(LEGACY.property);
    localStorage.removeItem(LEGACY.project);
    sessionStorage.removeItem(LEGACY.property);
    sessionStorage.removeItem(LEGACY.project);
  } catch {
    /* ignore */
  }
}
